<div class="fixed top-4 right-4 z-[99999] flex flex-col gap-3 w-full max-w-sm pointer-events-none">

   <div *ngFor="let msg of toastService.notifications()"
      class="pointer-events-auto relative bg-white border rounded-lg shadow-[0_4px_20px_-3px_rgba(0,0,0,0.15)] p-3 transition-colors duration-300 cursor-pointer animate-fade-in overflow-hidden"
      [style.borderColor]="msg.themeColor" (click)="onNotificationClick(msg)">

      <div class="absolute inset-0 pointer-events-none z-0" [style.backgroundColor]="msg.backgroundColor"></div>

      <div class="relative z-10 flex items-start gap-3">

         <div
            class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 bg-white/80 shadow-sm backdrop-blur-sm">
            <i [class]="'pi pi-'+msg.icon" class="text-sm" [style.color]="msg.themeColor"></i>
         </div>

         <div class="flex-1 min-w-0 pr-6">
            <div class="flex justify-between items-start mb-0.5">
               <p class="text-sm font-bold text-surface-800 leading-tight truncate">
                  {{ msg.title }}
               </p>
               <span class="text-[10px] text-surface-500 font-medium ml-2">Ahora</span>
            </div>
            <div class="text-[12px] text-surface-700 mt-0.5 line-clamp-3 leading-relaxed w-full"
               [innerHTML]="msg.description">
            </div>
         </div>

      </div>

      <button (click)="close($event, msg._id)"
         class="absolute top-3 right-2 z-20 text-surface-500 hover:text-surface-800 transition-colors bg-transparent border-0 cursor-pointer p-1">
         <i class="pi pi-times text-xs font-bold text-gray-600"></i>
      </button>

   </div>
</div>